module.exports = __webpack_public_path__ + "static/media/Pin_Job_Tow.22078388.svg";